/* istanbul ignore file */
import React from 'react'
import PropTypes from 'prop-types'
import { InfoBox } from 'commons/js/components/Map'
import { ParkingMapCard } from '../ParkingCard'
import { defaultLocale, currentLocale } from 'commons/js/locale'
import { IntlProvider } from 'react-intl'
import { messages } from 'commons/js/messages'
import theme from 'parking-search-map/js/theme'
import { EPProvider } from '@elparking/components'
import convertConstantToEPProviderFormat from 'commons/js/util/coverterGlobalConfig'

const INFO_WINDOW_WIDTH = 330

const getInfoBoxOptions = () => ({
    closeBoxURL: '',
    alignBottom: true,
    enableEventPropagation: true,
    pixelOffset: new window.google.maps.Size(-INFO_WINDOW_WIDTH / 2, -10),
    boxStyle: {
        width: `${INFO_WINDOW_WIDTH}px`,
        overflow: 'visible',
        padding: '10px',
    },
})

class ParkingInfoBox extends React.Component {
    static propTypes = {
        parking: PropTypes.object,
        computeDistanceTo: PropTypes.func,
        buildParkingUrl: PropTypes.func,
    }

    render () {
        const { parking, computeDistanceTo, buildParkingUrl } = this.props

        const position = new window.google.maps.LatLng(parking.latitude, parking.longitude)

        return (
            <InfoBox
              position={position}
              options={getInfoBoxOptions()}
            >
                <IntlProvider locale={currentLocale} defaultLocale={defaultLocale} messages={messages[currentLocale]}>
                    <EPProvider theme={theme} {...convertConstantToEPProviderFormat()}>
                        <ParkingMapCard
                          parking={parking}
                          computeDistanceTo={computeDistanceTo}
                          buildParkingUrl={buildParkingUrl}
                        />
                    </EPProvider>
                </IntlProvider>
            </InfoBox>
        )
    }
}

export default ParkingInfoBox
